/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { sendRequestAndReceiveResponse, filterNames, filterModels, toFileNameLookupBody } from '../common/common';
import { getDownloadsDetailonNameEndPoint } from '../common/constants';

const UPDATE_SELECTED_FAMILIES = 'UPDATE_SELECTED_FAMILIES';
const UPDATE_SELECTED_PRODUCTNAMES = 'UPDATE_SELECTED_PRODUCTNAMES';
const UPDATE_SELECTED_PRODUCTMODELS = 'UPDATE_SELECTED_PRODUCTMODELS';
const DOWNLOAD_INFORMATION_CHANGE = 'DOWNLOAD_INFORMATION_CHANGE';
const DOWNLOAD_MODELCODE_CHANGE = 'DOWNLOAD_MODELCODE_CHANGE';
const FIREWARE_TYPE_CHANGE = 'FIREWARE_TYPE_CHANGE';
const RELEASE_DATE_CHANGE = 'RELEASE_DATE_CHANGE';
const INTRODUCTION_DATE_CHANGE = 'INTRODUCTION_DATE_CHANGE';
const DOWNLOADS = 'DOWNLOADS';
const CLEAR_UPLOAD_DOWNLOADS_STORE = 'CLEAR_UPLOAD_DOWNLOADS_STORE';
const HANDLE_UPLOAD_DIALOG_CLICK = 'HANDLE_UPLOAD_DIALOG_CLICK';
const UPDATE_EDIT_DOWNLOAD_DATA = 'UPDATE_EDIT_DOWNLOAD_DATA';
const UPDATE_FILE_NAME = 'UPDATE_FILE_NAME';
const UPDATE_FILE_TYPE = 'UPDATE_FILE_TYPE';
const UPDATE_FILE_SIZE = 'UPDATE_FILE_SIZE';
const UPDATE_EDIT_DOWNLOAD_DATA_USING_UPLOAD = 'UPDATE_EDIT_DOWNLOAD_DATA_USING_UPLOAD';
const LOADING_DOWNLOAD_DETAIL_ON_NAME = 'LOADING_DOWNLOAD_DETAIL_ON_NAME';
const UPDATE_UPLOAD_FAMILIES = 'UPDATE_UPLOAD_FAMILIES';
const UPDATE_UPLOAD_NAMES = 'UPDATE_UPLOAD_NAMES';
const UPDATE_UPLOAD_MODELS = 'UPDATE_UPLOAD_MODELS';
const UPDATE_FIRM_TYPES = 'UPDATE_FIRM_TYPES';
const DOWNLOADS_STATUS_CHANGE = 'DOWNLOADS_STATUS_CHANGE';
const DOWNLOADS_AUTOSYNC_CHANGE = 'DOWNLOADS_AUTOSYNC_CHANGE';
const colors: Array<string> = ['#CFE1EE', '#DFE9D6', '#FFF2CC', '#FFE8CC', '#F4D1D3'];

const initialState = {
    data: {},
    autosync: true,
    status: true,
    fileinstructions: '',
    comments: '',
    downloadsClassificationModelCodeMapping: [],
    releaseDate: new Date(),
    introductionDate: null,
    firmwaretypes: [],
    firmwareType: 0,
    uploadDialogOpen: false,
    isDetailLoadingOnDownloadName: false,
    uploadDetails: { families: [], productNames: [], productModels: [] },
    isFileChanged: false,
    isEdit: false
}

export const actionCreators = {
    UpdateUploadFamilies: (families: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_UPLOAD_FAMILIES, families });
    },
    UpdateSelectedFamilies: (selectedFamilies: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_SELECTED_FAMILIES, selectedFamilies });
    },
    FilterUploadNames: (productFamilies: any, selectedFamilies: any) => async (dispatch: any, getState: any) => {
        const productNames: any = filterNames(productFamilies, selectedFamilies);
        dispatch({ type: UPDATE_UPLOAD_NAMES, productNames });
    },
    UpdateSelectedProductNames: (SelectedProductNames: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_SELECTED_PRODUCTNAMES, SelectedProductNames });
    },
    FilterUploadModels: (productNames: any, selectedProductNames: any) => async (dispatch: any, getState: any) => {
        const productModels: any = filterModels(productNames, selectedProductNames);
        dispatch({ type: UPDATE_UPLOAD_MODELS, productModels });
    },
    UpdateSelectedProductModels: (SelectedProductModels: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_SELECTED_PRODUCTMODELS, SelectedProductModels });
    },

    UpdateSelectedPdf: (selectedPdf: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: DOWNLOADS, selectedPdf });
    },
    clearAll: () => async (dispatch: any, getState: any) => {
        dispatch({ type: CLEAR_UPLOAD_DOWNLOADS_STORE });
    },
    handleUploadDialogClick: (isOpen: boolean) => async (dispatch: any, getState: any) => {
        dispatch({ type: HANDLE_UPLOAD_DIALOG_CLICK, isOpen });
    },
    UpdateEditDownloadData: (downloadsData: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_EDIT_DOWNLOAD_DATA, downloadsData });
    },
    UpdateFileName: (fileName: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_FILE_NAME, fileName });
        let a = { value: true };
        dispatch({ type: LOADING_DOWNLOAD_DETAIL_ON_NAME, a });
        const downloadsData = await sendRequestAndReceiveResponse(toFileNameLookupBody(fileName), getDownloadsDetailonNameEndPoint);
        if (downloadsData.downloadsId != undefined) {
            await dispatch({ type: UPDATE_EDIT_DOWNLOAD_DATA_USING_UPLOAD, downloadsData });
        }
        a = { value: false };
        dispatch({ type: LOADING_DOWNLOAD_DETAIL_ON_NAME, a });
    },

    UpdateFileType: (fileType: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_FILE_TYPE, fileType });
    },

    UpdateFileSize: (fileSize: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_FILE_SIZE, fileSize });
    },

    handleDownloadInformationChange: (event: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: DOWNLOAD_INFORMATION_CHANGE, event });
    },
    handleDownloadModelCodeChange: (event: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: DOWNLOAD_MODELCODE_CHANGE, event });
    },
    handlereleaseDateChange: (date: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: RELEASE_DATE_CHANGE, date });
    },
    handlefirewareTypeChange: (event: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: FIREWARE_TYPE_CHANGE, event });
    },

    Updatefirmwaretypes: (data: any) => async (dispatch: any, getState: any) => {
        let x: any = [{ id: 0, description: 'No entry' }].concat(data);
        dispatch({ type: UPDATE_FIRM_TYPES, x });
    },
    handleintroductionDateChange: (date: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: INTRODUCTION_DATE_CHANGE, date });
    },
    handleStatusChange: (event: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: DOWNLOADS_STATUS_CHANGE, event });
    },
    handleAutoSyncChange: (event: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: DOWNLOADS_AUTOSYNC_CHANGE, event });
    },
}

const getColors = (parentArray: any, selectedArray: any, fillArrayName: any) => {
    const selectedColors: any = [];
    parentArray.map((x: any) => {
        const a: any = selectedArray.indexOf(x.id);
        if (a != -1) {
            if (fillArrayName != '') {
                x.color = colors[a % colors.length];
                x[fillArrayName].forEach((y: any) => {
                    y.color = x.color;
                });
            }
            selectedColors.push(x.color);
        }
    });
    return selectedColors;
}
const getProductNames = (families: any, smd: any) => {
    const productNames: any = [];
    smd.familyData.forEach((family: any) => {
        const a = filterNames(families, [family.productFamilyId]);
        a.forEach((v: any) => { productNames.push(v); })
    });

    return productNames;
}

const getEditDownloadData = (smd: any) => {
    const names: any = [];
    const productmodels: any = [];
    const families: any = [];
    smd.familyData.forEach((x1: any) => {
        families.push(x1.productFamilyId);
        x1.nameList.forEach((x: any) => {
            names.push(x.productNameId);
            x.modelList.forEach((y: any) => {
                productmodels.push(y.productModelId);
            });
        });
    });
    return { names, productmodels, families };
}
export const reducer = (state: any, action: any) => {
    state = state || initialState;

    switch (action.type) {
        case UPDATE_SELECTED_FAMILIES:
            return {
                ...state,
                selectedFamilies: action.selectedFamilies
            };
        case UPDATE_SELECTED_PRODUCTNAMES: {
            const selectedNameColors: any = getColors(state.uploadDetails.productNames, action.SelectedProductNames, 'twodproductmodels');
            return {
                ...state,
                selectedProductNames: action.SelectedProductNames,
                selectedNameColors
            };
        }
        case UPDATE_SELECTED_PRODUCTMODELS: {
            const selectedModelColors: any = getColors(state.uploadDetails.productModels, action.SelectedProductModels, '');
            let dn: any = '';

            if (state.isFileChanged || state.isEdit) {
                dn = state.displayName;
            }
            else {
                let tempstring: any = '';
                state.uploadDetails.productModels.map((x: any) => {
                    if (action.SelectedProductModels.indexOf(x.id) != -1) {
                        tempstring += ", " + x.name;
                    }
                });
                dn = tempstring.substring(1);
            }

            return {
                ...state,
                selectedProductModels: action.SelectedProductModels,
                selectedModelColors,
                displayName: dn
            };
        }
        case DOWNLOAD_INFORMATION_CHANGE:
            return {
                ...state,
                [action.event.target.name]: action.event.target.value
            };
        case DOWNLOAD_MODELCODE_CHANGE:
            return {
                ...state,
                downloadsClassificationModelCodeMapping: JSON.parse(JSON.stringify(action.event))
            };
        case FIREWARE_TYPE_CHANGE:
            return {
                ...state,
                firmwareType: action.event.target.value
            };

        case RELEASE_DATE_CHANGE:
            return {
                ...state,
                releaseDate: new Date(new Date(action.date))
            };
        case INTRODUCTION_DATE_CHANGE:
            return {
                ...state,
                introductionDate: (action.date != null && action.date != undefined) ? new Date(action.date) : undefined
            };

        case UPDATE_FIRM_TYPES:
            return {
                ...state,
                firmwaretypes: action.x
            };
        case DOWNLOADS:
            return {
                ...state,
                selectedPdf: action.selectedPdf
            };
        case CLEAR_UPLOAD_DOWNLOADS_STORE:
            return initialState;
        case HANDLE_UPLOAD_DIALOG_CLICK:
            return {
                ...state,
                uploadDialogOpen: action.isOpen
            };
        case UPDATE_EDIT_DOWNLOAD_DATA: {
            const smd = action.downloadsData;
            const names = getProductNames(state.uploadDetails.families, smd);
            const editDownloadData = getEditDownloadData(smd);
            const models = filterModels(names, editDownloadData.names);
            const selectedNameColors = getColors(names, editDownloadData.names, 'twodproductmodels');
            const selectedModelColors = getColors(models, editDownloadData.productmodels, '');
            return {
                ...state,
                uploadDetails: { ...state.uploadDetails, productNames: names, productModels: models },
                selectedPdf: smd.presignedURL,
                selectedFamilies: editDownloadData.families,
                selectedProductNames: editDownloadData.names,
                selectedProductModels: editDownloadData.productmodels,
                originalProductModels: JSON.parse(JSON.stringify(editDownloadData.productmodels)),
                displayName: smd.displayName,
                fileName: smd.fileName,
                fileSize: smd.fileSize,
                status: smd.status,
                autosync: smd.autoSync,
                description: smd.description,
                revision: smd.revision,
                releaseDate: new Date(smd.releaseDate),
                introductionDate: smd.introductionDate != null && smd.introductionDate != undefined ? new Date(smd.introductionDate) : null,
                firmwareType: smd.firmwareType,
                downloadsClassificationModelCodeMapping: smd.downloadsClassificationModelCodeMapping,
                comments: smd.comments,
                fileinstructions: smd.fileInstructions,
                isEdit: true,
                selectedNameColors,
                selectedModelColors,
            };
        }
        case UPDATE_FILE_NAME:
            return {
                ...state,
                fileName: action.fileName
            };
        case UPDATE_FILE_TYPE:
            return {
                ...state,
                fileType: action.fileType
            };
        case UPDATE_FILE_SIZE:
            return {
                ...state,
                fileSize: action.fileSize
            };
        case LOADING_DOWNLOAD_DETAIL_ON_NAME:
            return {
                ...state,
                isDetailLoadingOnDownloadName: action.a.value
            };
        case UPDATE_EDIT_DOWNLOAD_DATA_USING_UPLOAD: {
            const smd = action.downloadsData;
            const names = getProductNames(state.uploadDetails.families, smd);
            console.log(names);
            const editDownloadData = getEditDownloadData(smd);
            const models = filterModels(names, editDownloadData.names);
            console.log(models);
            const selectedNameColors = getColors(names, editDownloadData.names, 'twodproductmodels');
            const selectedModelColors = getColors(models, editDownloadData.productmodels, '');
            return {
                ...state,
                uploadDetails: { ...state.uploadDetails, productNames: names, productModels: models },
                selectedFamilies: editDownloadData.families,
                selectedProductNames: editDownloadData.names,
                selectedProductModels: editDownloadData.productmodels,
                originalProductModels: JSON.parse(JSON.stringify(editDownloadData.productmodels)),
                selectedPdf: smd.presignedURL,
                displayName: smd.displayName,
                fileName: smd.fileName,
                status: smd.status,
                autosync: smd.autoSync,
                description: smd.description,
                revision: smd.revision,
                releaseDate: new Date(smd.releaseDate),
                firmwareType: smd.firmwareType,
                introductionDate: smd.introductionDate != null && smd.introductionDate != undefined ? new Date(smd.introductionDate) : null,
                downloadsClassificationModelCodeMapping: smd.downloadsClassificationModelCodeMapping,
                comments: smd.comments,
                fileinstructions: smd.fileInstructions,
                isDetailLoadingOnDownloadName: false,
                selectedNameColors,
                selectedModelColors,
                isFileChanged: true
            };
        }
        case UPDATE_UPLOAD_FAMILIES:
            return {
                ...state,
                uploadDetails: { ...state.uploadDetails, families: action.families }
            };
        case UPDATE_UPLOAD_NAMES:
            return {
                ...state,
                uploadDetails: { ...state.uploadDetails, productNames: action.productNames }
            };
        case UPDATE_UPLOAD_MODELS:
            return {
                ...state,
                uploadDetails: { ...state.uploadDetails, productModels: action.productModels }

            };
        case DOWNLOADS_STATUS_CHANGE:
            return {
                ...state,
                status: action.event.target.checked

            };
        case DOWNLOADS_AUTOSYNC_CHANGE:
            return {
                ...state,
                autosync: action.event.target.checked

            };

    }
    return state;
};
